// extracted by mini-css-extract-plugin
export default {"container":"spi-info-view_container__h2uxy"};